<template>
    <div class="radio-box-list flex border-box flex-center-cz ">
        <div v-for="item in data" class="item flex border-box flex-center-cz margin-right-l">
            <input :name="dataId" type="radio" v-model="val" @change="change(item.value)"  :disabled="disabled" :value="item.value">
            <div class="flex flex-center-sp " >{{item.text}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'RadioBoxList',
        props:{
            data:{},
            dataId:{},
            value:{},
            disabled: false,
        },
        watch:{
            value:{
                handler(newValue) {
                    console.log("newValue", newValue);
                    this.val = newValue;
                },
                immediate: true,
                deep: true   //深度监听                
            }
        },
        model: {
            prop: "value",
            event: "change"
        },
        data() {
            return {
                val : null
            }
        },
        methods:{
            change(item) {
                this.val = item;
                console.log(this.val);
                this.$emit("change", this.val)
            }
        }
    }
</script>

<style scoped>

    .radio-box-list {
        background-color: transparent;
    }


    .item input {
        width: 18px;
        height: 18px;
    }
</style>


// WEBPACK FOOTER //
// src/components/radioBoxList/RadioBoxList.vue